import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "Suggestions",
  ref: "containerRef",
  tabindex: "-1"
}
const _hoisted_2 = {
  class: "List",
  tabindex: "-1",
  ref: "listRef"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Suggestion = _resolveComponent("Suggestion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h3", {
      class: "Title",
      tabindex: "-1"
    }, "Search Suggestions", -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestions, (suggestion, index) => {
        return (_openBlock(), _createBlock(_component_Suggestion, {
          suggestion: suggestion,
          index: index
        }, null, 8 /* PROPS */, ["suggestion", "index"]))
      }), 256 /* UNKEYED_FRAGMENT */))
    ], 512 /* NEED_PATCH */)
  ], 512 /* NEED_PATCH */))
}